import React from 'react';
import { observer } from 'mobx-react';
import { Button, Table, Tooltip } from 'antd';
import { Catcher, LinkComponent } from '../../';
import { tokenManager } from '../../../REST';
import { useProfile, useRouterStore, useUiSearch, useUsersTable } from '../../../hooks';
import { cleanProfileStore, getProfileInfo, impersonateUser, setUiInitPageList } from '../../../middleware';
import { lightText } from '../../../instruments';
import { tF } from '../../../translate';

export const ImpersonateUserTable: React.FC = observer(() => {
    const list = useUsersTable();
    const routerStore = useRouterStore();
    const currentUserId = useProfile().id;
    const search = useUiSearch();

    const impersonateAsUser = async (id: string) => {
        const { isError, resp } = await impersonateUser(id);

        const { token } = resp as any;

        if (!isError) {
            await tokenManager.enableImpersonatedToken(token);
            await cleanProfileStore();
            setUiInitPageList();
            await getProfileInfo();
            await routerStore.goTo('Dashboard');
        }
    };

    const tableColumns = [
        {
            title: 'Impersonate User',
            dataIndex: 'impersonateUser',
        },
        {
            title: tF('First name'),
            dataIndex: 'firstName',
        },
        {
            title: tF('Last name'),
            dataIndex: 'lastName',
        },
        {
            title: tF('Email'),
            dataIndex: 'email',
        },
        {
            title: tF('Company'),
            dataIndex: 'companyName',
        },
        {
            title: tF('Role'),
            dataIndex: 'userType',
        },
    ];

    const tableData = list.map((user) => ({
        ...user,
        key: user.id,
        firstName: <LinkComponent currentListComponent={'UsersList'} id={user.id} name={user.firstName} isLight />,
        lastName: <LinkComponent currentListComponent={'UsersList'} id={user.id} name={user.lastName} isLight />,
        email: <LinkComponent currentListComponent={'UsersList'} id={user.id} name={user.email} isLight />,
        companyName: (
            <LinkComponent currentListComponent={'CompaniesList'} id={user.companyId} name={user.companyName} isLight />
        ),
        userType: lightText(user.userType, search),
        impersonateUser: (
            <Tooltip title={currentUserId == user.id ? 'Cannot Impersonate as yourself.' : 'Impersonate as this user.'}>
                <Button
                    disabled={currentUserId == user.id}
                    danger
                    ghost
                    onClick={() => impersonateAsUser(user.id)}
                >{`Impersonate as`}</Button>
            </Tooltip>
        ),
    }));

    return (
        <Catcher>
            <Table
                dataSource={tableData}
                columns={tableColumns}
                pagination={false}
                className={'table-theme'}
                size={'middle'}
            />
        </Catcher>
    );
});
